import React, { useEffect, useState } from "react";
import "./Personal_Info.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPencil,
  faPencilSquare,
  faPenToSquare,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useForm, Controller } from "react-hook-form";
import Green_Btn from "../../common_components/common_btn/green_btn/Green_Btn";
import Gray_Btn from "../../common_components/common_btn/gray_btn/Gray_Btn";
import Delete_Contact_Modal from "../../common_components/common_modal/delete_contact_modal/Delete_Contact_Modal";
import Success_Modal from "../../common_components/common_modal/success_modal/Success_Modal";
import { useDispatch, useSelector } from "react-redux";
import { myAccount, myaccountUpdate } from "../../../features/my_account/Slice";
import { formatDate } from "../../../utils/common";
import Select from "react-select";
import { CountryCode } from "../../../features/master/masterSlice";

const Personal_Info = () => {
  const [showSuccessModal, setShowSucsessModal] = useState(false);
  const [showSuccessModal2, setShowSucsessModal2] = useState(false);

  const dispatch = useDispatch();
  const user = useSelector((state) => state.myaccount.addMyaccount);
  const [showAlternate, setShowAlternate] = useState(false);

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setError,
    clearErrors,
    setValue,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  useEffect(() => {
    dispatch(myAccount());
  }, [dispatch]);

  const getUser = async () => {
    reset({
      name: user.name || "",
      last_name: user.last_name || "",
      email: user.email || "",
      contact_no: user.contact_no || "",
      country_code_id: user.country_code_id || "",
      alternate_no: user.alternate_no || "",
      // gender_id: String(user.gender_id),
      date_of_birth: user.date_of_birth || "", // convert to string for radio
    });
    setValue("date_of_birth", formatDate(user.date_of_birth || ""));
    if (user.alternate_no) {
      setShowAlternate(true);
    }
  };

  useEffect(() => {
    if (user) {
      getUser();
    }
  }, [user, reset]);

  const [isEdit, setIsEdit] = useState(false);
  const [showModal, setShowmodal] = useState(false);
  const [number, setNumber] = useState();

  const onSubmit = async (data) => {
    const res = await dispatch(myaccountUpdate(data));

    if (res.meta?.requestStatus === "fulfilled") {
      setShowSucsessModal(true);
      await dispatch(myAccount());
      setIsEdit(false);
      
    setTimeout(() => {
       setShowSucsessModal(false);
        // props?.onHide()
    }, 3000);
    } else if (res.meta?.requestStatus === "rejected") {
      if (res.payload?.data?.errors?.email) {
        setError("email", {
          type: "manual",
          message: res.payload?.data?.errors?.email,
        });
      }
      if (res.payload?.data?.errors?.contact_no) {
        setError("contact_no", {
          type: "manual",
          message: res.payload?.data?.errors?.contact_no,
        });
      }
    }
  };

  const getInitials = (firstName = "", lastName = "") => {
    const firstInitial = firstName?.charAt(0) || "";
    const lastInitial = lastName ? lastName.charAt(0) : "";
    return `${firstInitial}${lastInitial}`.toUpperCase();
  };

  const deleteContact = (type) => {
    setShowmodal(true);
    if (type == "alternate_no") {
      setNumber("alternate_no");
    } else {
      setNumber("contact_no");
    }
  };

  const options = [
    { value: "+91", label: "+91" },

    { value: "+91", label: "+91" },

    { value: "+91", label: "+91" },
  ];

  const countryCode = useSelector((state) => state.master.country_code);

  useEffect(() => {
    dispatch(CountryCode());
  }, []);



  return (
    <section className="Personal_Info">
      <div className="top_div">
        <div className="user_img_div">
          {/* {user?.image ? (
            <img src={user.image} alt="User" className="user_img" />
          ) : ( */}
            <div className="initials_box">
              {getInitials(user?.name, user?.last_name)}
            </div>
          {/* )} */}
        </div>

        {!isEdit && (
          <div
            className="edit_icon_holder"
            onClick={() => {
              setIsEdit(true);
            }}
          >
            <FontAwesomeIcon icon={faPenToSquare} className="edit_icon" />
          </div>
        )}
      </div>

      <div className="personal_info_form">
        <Form>
          <div className="row">
            <div className="col-sm-6">
              <Form.Group
                className="input_group"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>First Name*</Form.Label>
                <Form.Control
                  disabled={!isEdit}
                  type="text"
                  name="name"
                  {...register("name", {
                    required: "Name is required",
                  })}
                />
                {errors?.name && (
                  <sup className="text-danger">{errors?.name?.message}</sup>
                )}
              </Form.Group>
            </div>

            <div className="col-sm-6">
              <Form.Group
                className="input_group"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>Last Name*</Form.Label>
                <Form.Control
                  disabled={!isEdit}
                  type="text"
                  name="last_name"
                  {...register("last_name", {
                    required: "Last Name is required",
                  })}
                />
                {errors?.last_name && (
                  <sup className="text-danger">
                    {errors?.last_name?.message}
                  </sup>
                )}
              </Form.Group>
            </div>

            <div className="col-sm-6">
              <Form.Group
                className="input_group"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>Email Address*</Form.Label>
                <Form.Control
                  disabled={!isEdit}
                  type="text"
                  name="email"
                  {...register("email", {
                    required: "Email is required",
                      pattern: {
                    value: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
                    message: "Email Address Invalid",
                  },

                  })}
                />
                {errors?.email && (
                  <sup className="text-danger">{errors?.email?.message}</sup>
                )}
              </Form.Group>
            </div>

            <div className="col-sm-6">
              <Form.Group
                className="input_group mobile_group"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>Mobile Number*</Form.Label>
                {/* <Controller
                  disabled={!isEdit}
                  name="contact_no"
                  control={control}
                  rules={{
                    required: "contact number is required",
                    pattern: {
                      value: /^\+?\d{1,4}[-\s]?\d{10}$/,
                      message:
                        "Invalid number format. Please enter a valid number with an optional country code",
                    },
                  }}
                  render={({ field }) => (
                    <PhoneInput
                      disabled={!isEdit}
                      country={"in"}
                      {...field}
                      type="text"
                      placeholder="Enter Mobile Number"
                      maxLength={10}
                    />
                  )}
                /> */}

                <div className="mobinputsec">
                  <div className="contcode">
                    <Controller
                      name="country_code_id"
                      control={control}
                      rules={{ required: "Select Country Code" }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          isDisabled={true}
                          options={countryCode}
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              borderColor: errors.country_code_id
                                ? "red"
                                : baseStyles.borderColor,
                            }),
                          }}
                        />
                      )}
                    />
                  </div>
                  <div className="inputdiv">
                    <Form.Control
                      disabled={true}
                      placeholder="Enter Contact Number"
                      aria-label="Contact"
                      aria-describedby="basic-addon1"
                      type="text"
                      maxLength={10}
                      {...register("contact_no", {
                        required: "Contact number is required",
                        pattern: {
                          value: /^[0-9]{10}$/,
                          message: "Contact number must be 10 digits",
                        },
                      })}
                      onKeyPress={(e) => {
                        if (!/[0-9]/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>
                </div>

                {errors?.contact_no && (
                  <sup className="text-danger">
                    {errors?.contact_no?.message}
                  </sup>
                )}

                {isEdit && (
                  <p
                    className="bottom_text"
                    onClick={() => setShowAlternate(!showAlternate)}
                  >
                    {showAlternate ? "Hide" : "Add Alternative Number"}
                  </p>
                )}
              </Form.Group>
            </div>

            <div className="col-sm-6">
              <Form.Group
                className="input_group"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>Date of Birth*</Form.Label>
                <Form.Control
                  disabled={!isEdit}
                  type="date"
                  name="date_of_birth"
                  {...register("date_of_birth", {
                    required: "Date of Birth is required",
                  })}
                />
                {errors?.date_of_birth && (
                  <sup className="text-danger">
                    {errors?.date_of_birth?.message}
                  </sup>
                )}
              </Form.Group>
            </div>

            {showAlternate && (
              <div className="col-sm-6">
                <Form.Group
                  className="input_group mobile_group"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Alternate Mobile Number*</Form.Label>
                  <Controller
                    name="alternate_no"
                    control={control}
                    rules={{
                      // required: "Field is required",
                      pattern: {
                        value: /^\+?\d{1,4}[-\s]?\d{10}$/,
                        message:
                          "Invalid number format. Please enter a valid number with an optional country code",
                      },
                    }}
                    render={({ field }) => (
                      <PhoneInput
                        country={"in"}
                        {...field}
                        type="text"
                        placeholder="Enter Mobile Number"
                        maxLength={10}
                      />
                    )}
                  />
                  {/* 
                                    <div className='delete_icon'>
                                        <FontAwesomeIcon icon={faTrash} className='delete_icon' onClick={() => { setShowAlternate(false) }} />
                                    </div> */}
                </Form.Group>
              </div>
            )}

            {isEdit && (
              <div className="btns_holder">
                <div className="save_btn">
                  <Green_Btn
                    btn_name="Update"
                    onClick={handleSubmit(onSubmit)}
                  />
                </div>
                <div className="cancel_btn">
                  <Gray_Btn
                    btn_name="Cancel"
                    onClick={() => {
                      getUser();
                      setIsEdit(false);
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </Form>
      </div>

      <Delete_Contact_Modal
        modal_title="Delete Contact"
        message="Are you sure, you want to delete this contact?"
        number={number}
        id={user?.id}
        show={showModal}
        onHide={() => {
          setShowmodal(false);
        }}
        yesAction={() => {
          setShowmodal(false);
          setShowSucsessModal2(true);
        }}
        noAction={() => {
          setShowmodal(false);
        }}
      />

      <Success_Modal
        show={showSuccessModal2}
        onHide={() => {
          setShowSucsessModal2(false);
        }}
        successText="Contact Deleted!"
      />

      <Success_Modal
        show={showSuccessModal}
        onHide={() => {
          setShowSucsessModal(false);
        }}
        successText="Information Updated!"
      />
    </section>
  );
};

export default Personal_Info;
